import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ProductsState } from '../../types/products';

const initialState: ProductsState = {
  categories: [],
  products: [],
  selectedCategoryId: null,
  loading: false,
  error: null,
};

export const productsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    setSelectedCategory: (state, action: PayloadAction<string | null>) => {
      state.selectedCategoryId = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  setSelectedCategory,
  setLoading,
  setError,
  clearError,
} = productsSlice.actions;

export default productsSlice.reducer;